// @flow

import React, { PureComponent } from 'react';

import { STATUS_SUCCESS } from 'constants/statusConstants';

import BillboardDirect from 'components/billboard/BillboardDirect';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import CompetitionCardArticle from 'components/fragments/card/CompetitionCardArticle';
import Loading from 'components/fragments/Loading';

import type { CategoryArticleType, ArticleType } from 'types/Article';

// import { formatFullDate } from 'utils/dateUtils'; @TODO when there'll be a date in news
import { getNews } from 'utils/articleUtils';

import type { Status } from 'types/Status';

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
  clubName: string,
  settingsStatus: Status,
  actualite_ffr_vers_ecosysteme: {
    featured_media: {
      src: string,
      sizes: {}
    },
    date: string,
    link: string,
    title: {
      raw: string,
      rendered: string
    },
    label: {
      name: string,
      slug: string
    }
  },
  actualite_une: {
    link: string,
    title: string,
    label: string,
    featured_image: string
  },
  actualites_une_titre: string,
  actualites_une_description: string
};

export type DispatchProps = {
  fetchArticlesStaticCategories: () => void
};

type Props = {
  rowClassNames: string
} & DispatchProps &
  StateProps;

type State = {
  news: ArticleType[]
};

export default class News extends PureComponent<Props, State> {
  state = {
    news: []
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const { categoriesArticle } = props;
    if (categoriesArticle.length) {
      const news = getNews(categoriesArticle);
      return { news };
    }
    return null;
  }

  componentDidMount() {
    const { fetchArticlesStaticCategories } = this.props;
    fetchArticlesStaticCategories();
  }

  render() {
    const {
      categoriesArticle,
      rowClassNames,
      clubName,
      settingsStatus,
      actualite_ffr_vers_ecosysteme,
      actualite_une,
      actualites_une_description,
      actualites_une_titre
    } = this.props;

    const news_forcee = actualite_ffr_vers_ecosysteme && actualite_ffr_vers_ecosysteme.title && actualite_ffr_vers_ecosysteme.title.raw;
    const news_une = actualite_une && actualite_une.title;
    // const news_une = false;

    const { news } = this.state;
    if (!news || news.length === 0) {
      return '';
    }
    const { link, label, title, illustration, rencontre_details } = news[0];
    const isNews = link && label && title;
    const mainNewsClass = rencontre_details ? 'box card card--billboard is-home has-score' : 'box card card--billboard is-home';

    if (settingsStatus !== STATUS_SUCCESS) {
      return <Loading />;
    }
    return (
      <>
        <h2 className="mb-1">{actualites_une_titre ? actualites_une_titre : `Actualités du club ${clubName}`}</h2>
        <p className="mb-3">
          {actualites_une_description
            ? actualites_une_description
            : `Découvrez nos équipes en détails, leurs résulats, prochains matchs, évènements et actualités liées - ${clubName}`}
        </p>
        <div className={rowClassNames}>
          <div className="col col-md-6 col-lg-8 mb-2 mb-md-0">
            {news_forcee && (
              <a
                title={`Lire la suite de l'article : ${actualite_ffr_vers_ecosysteme.title.rendered}`}
                href={`${actualite_ffr_vers_ecosysteme.link}`}
                target="_blank"
                className={mainNewsClass}
                rel="noopener noreferrer"
              >
                <div className="card--billboard__content box">
                  <BackgroundImage
                    className="card__thumbnail img-blue"
                    illustration={actualite_ffr_vers_ecosysteme.featured_media.src}
                    srcset={actualite_ffr_vers_ecosysteme.featured_media.sizes}
                  />
                  <div className="card__body">
                    <h3 className="card__title ft-h2">{actualite_ffr_vers_ecosysteme.title.rendered}</h3>
                  </div>
                  <div className="card__footer">
                    <span className="btn">
                      <i className="icon icon-chevron-right link-icon is-dark is-inline" />
                      <span>Lire la suite</span>
                    </span>
                  </div>
                  <div className="card__type">
                    <span className="label">{actualite_ffr_vers_ecosysteme.label.name}</span>
                  </div>
                </div>
              </a>
            )}
            {news_une && (
              <a
                title={`Lire la suite de l'article : ${actualite_une.title}`}
                href={`${actualite_une.link}`}
                target="_blank"
                className={mainNewsClass}
                rel="noopener noreferrer"
              >
                <div className="card--billboard__content box">
                  <BackgroundImage className="card__thumbnail img-blue" illustration={actualite_une.featured_image} />
                  <div className="card__body">
                    <h3 className="card__title ft-h2">{actualite_une.title}</h3>
                  </div>
                  <div className="card__footer">
                    <span className="btn">
                      <i className="icon icon-chevron-right link-icon is-dark is-inline" />
                      <span>Lire la suite</span>
                    </span>
                  </div>
                  <div className="card__type">
                    <span className="label">{actualite_une.label}</span>
                  </div>
                </div>
              </a>
            )}
            {!news_forcee && !news_une && isNews && (
              <a href={link} title={title} className={mainNewsClass}>
                <div className="card--billboard__content box">
                  <BackgroundImage className="card__thumbnail img-blue" illustration={illustration} />
                  <div className="card__body">
                    {/* <p className='card__date ft-h6'>{formatFullDate(date)}</p>
                  @TODO : plug when there'll be a date in top_news */}
                    <h3 className="card__title ft-h2">{title}</h3>
                  </div>
                  <div className="card__footer">
                    <span className="btn">
                      <i className="icon icon-chevron-right link-icon is-dark is-inline" />
                      <span>Lire la suite</span>
                    </span>
                  </div>
                  <div className="card__type">
                    <span className="label">{label.name}</span>
                  </div>
                </div>
                {rencontre_details && rencontre_details.id && <CompetitionCardArticle match={rencontre_details} isOver />}
              </a>
            )}
          </div>
          <div className="col col-md-6 col-lg-4">
            {news.length > 0 && (
              <BillboardDirect news={news.slice(news_forcee || news_une ? 0 : 1)} categoriesArticle={categoriesArticle} />
            )}
          </div>
        </div>
      </>
    );
  }
}
